import { render, staticRenderFns } from "./LinkApp.vue?vue&type=template&id=7ab43478&scoped=true&"
import script from "./LinkApp.vue?vue&type=script&lang=js&"
export * from "./LinkApp.vue?vue&type=script&lang=js&"
import style0 from "./LinkApp.vue?vue&type=style&index=0&id=7ab43478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab43478",
  null
  
)

/* custom blocks */
import block0 from "./LinkApp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLinkWr: require('/app/components/base/LinkWr.vue').default})
